var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"depressed":"","dark":_vm.isSelected,"color":_vm.isSelected ? 'primary' : ''},on:{"click":function($event){return _vm.$emit('onClick')}}},[(_vm.stockImage)?_c('v-avatar',[_c('img',{attrs:{"src":_vm.stockImage}})]):_vm._e(),_vm._v(" "),_vm._t("text")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26506ff4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/ecommerce/ProductOptionItem.vue
// module id = null
// module chunks = 